import PropTypes from "prop-types";
import { useTranslation } from "next-i18next";
import Swatch from "../Swatch";
import styles from "./styles/view.module.css";

const ProductFormSelection = ({
  navigation,
  options,
  handleNavigationChange,
  handleOptionChange,
  openSizeGuide,
  product
}) => {
  const { t } = useTranslation("productpage");
  
  return (
    <div className={styles.productSelection}>
      {navigation && navigation.length > 1 && (
        <Swatch
          data={navigation}
          heading={t("colour")}
          name={"colour"}
          updateVariant={handleNavigationChange}
          previewOnHover={handleNavigationChange}
          product={product}
        />
      )}

      {Array.from(options.keys()).map((key) => {
        if (options.get(key).length > 1) {
          const heading = key === "Size" ? t("size") : key;
          return (
            <Swatch
              key={key.toLowerCase()}
              name={key.toLowerCase()}
              data={Array.from(options.get(key).values())}
              heading={heading}
              updateVariant={handleOptionChange}
              openSizeGuide={openSizeGuide}
              product={product}
            />
          );
        }
      })}
    </div>
  );
};

ProductFormSelection.propTypes = {
  navigation: PropTypes.array,
  options: PropTypes.object,
  handleNavigationChange: PropTypes.func,
  handleOptionChange: PropTypes.func,
  toggleModal: PropTypes.func,
};

export default ProductFormSelection;
